module.exports = __webpack_public_path__ + "market/static/img/login-weixin.3d7c66d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login-weixin.jpeg
// module id = vHdC
// module chunks = 1